// luxury-animated-stats.js
document.addEventListener('DOMContentLoaded', () => {
  const statsSections = document.querySelectorAll('.luxury-stats');

  if (!statsSections.length) return;

  const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      // easeOutExpo
      const easeProgress = progress === 1 ? 1 : 1 - Math.pow(2, -10 * progress);
      obj.innerHTML = Math.floor(easeProgress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        obj.innerHTML = end; // Ensure exact final value
      }
    };
    window.requestAnimationFrame(step);
  };

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const numbers = entry.target.querySelectorAll('.luxury-stat-item__number');
        numbers.forEach(num => {
          const targetVal = parseInt(num.getAttribute('data-target'), 10);
          if (!isNaN(targetVal)) {
            animateValue(num, 0, targetVal, 2000);
          }
        });
        observer.unobserve(entry.target); // Only animate once
      }
    });
  }, observerOptions);

  statsSections.forEach(section => {
    observer.observe(section);
  });
});
